import React, { Component } from "react"
import { Switch, withRouter } from "react-router-dom"
import ReactGA from "react-ga"

import Routes from "./Routes.js"
import Header from "../components/Header.js"
import Footer from "../components/Footer.js"

import history from "../helpers/history.js"

class App extends Component {
  componentDidMount() {
    ReactGA.initialize("UA-138139248-1", { debug: false })

    ReactGA.set({ anonymizeIp: true })
    ReactGA.set({ page: window.location.pathname })
    ReactGA.pageview(window.location.pathname)

    history.listen(location => {
      const googleUrl = location.pathname + location.search
      ReactGA.set({ anonymizeIp: true })
      ReactGA.set({ page: googleUrl })
      ReactGA.pageview(googleUrl)
    })
  }

  render() {
    return (
      <div className = { "App" }>
        <div className = { "content" }>
          <Header />
          <Switch>
            <Routes />
          </Switch>
        </div>
        <Footer/>
      </div>
    )
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/containers/App.js